import { inheritActionOwner, isActionCurrent } from '@/_core/fluxstore/dispatchOwnership';
import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { AddNewActivity } from './addNewActivity';
import { SaveNewActivity } from './saveNewActivity';
import { AddPersonaToCard } from '../persona/addPersonaToCard';
import { createDebugger } from '@/_core/utils/debug';

const debug = createDebugger('pages:main:storymap:store:actions:newCard:addActivityFromAi');
const { registerMiddleware, dispatch } = useStorymapStore();

export class AddActivityFromAi extends Action<StorymapState> {
    public static ACTION_TYPE = 'AddActivityFromAi';
    public _cardId: string;

    public constructor(public title: string, public order: number, public personaId: string = null) {
        super(AddActivityFromAi.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: AddActivityFromAi): Promise<boolean> => {
    debug('AddActivityFromAi', action);

    const addAction = inheritActionOwner(action, new AddNewActivity(action.order, true));
    await dispatch(addAction);
    if (!isActionCurrent(action)) return false;
    action._cardId = addAction._cardId;
    await dispatch(inheritActionOwner(action, new SaveNewActivity(action._cardId, action.title)));
    if (!isActionCurrent(action)) return false;

    if (action.personaId && action.personaId.trim() !== '') {
        await dispatch(inheritActionOwner(action, new AddPersonaToCard(action._cardId, action.personaId)));
    }

    debug('AddActivityFromAi end', action);

    return true;
};

//@ts-ignore
registerMiddleware(AddActivityFromAi.ACTION_TYPE, middleware);
